export default function (http) {
    return {


        // queryByPage (data){
        //     return http.json({
        //         url: `/order/add/send/query?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
        //         data
        //     });
        // },

        query(data){
            return http.json({
                url: `/order/add/send/query?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },

        queryByPage(data) {
            return http.json({
                url: `/order/add/send/queryByPage?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },

        queryOrderByPage(data) {
            return http.json({
                url: `/order/base/query?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },


        queryAllByBuy(data) {
            return http.json({
                url: `/order/item/queryAllByBuy?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },


        export(data) {
            return http.json({
                url: `/order/add/send/export`,
                data
            });
        },


        queryMatchNoNOYNull(data) {
            return http.json({
                url: `/order/add/send/queryMatchNoNOYNull?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },

        updateOrderState(data) {
            return http.json({
                url: `/order/add/send/updateOrderState`,
                data
            })
        },


        pass(data) {
            return http.json({
                url: `/order/add/send/pass`,
                data
            })
        },
        fail(data) {
            return http.json({
                url: `/order/add/send/fail`,
                data
            })
        },
        getInfo(data) {
            return http.json({
                url: `/order/add/send/get?id=${data.id}`,
                data
            })
        },

        saveInfo(data) {
            return http.json({
                url: `/order/add/send/save`,
                data
            })
        },

        saveOrderInfo(data) {
            return http.json({
                url: `/order/base/save`,
                data
            })
        },

        saveBatch(data) {
            return http.json({
                url: `/order/add/send/saveBatch`,
                data
            })
        },
        delete(data) {
            return http.json({
                url: `/order/add/send/delete`,
                data
            })
        },

        deleteById(data) {
            return http.json({
                url: `/order/add/send/deleteById`,
                data
            })
        },

        queryProByPage(data) {
            return http.json({
                url: `/erp/pro/base/query?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },
        /**
         * 查询字典列表
         * @param data
         * @return {*}
         */
        queryProInfoAndStock(data) {
            return http.json({
                url: '/erp/rep/house/queryProInfoAndStock',
                data
            })
        },

        cancel(data) {
            return http.json({
                url: `/order/add/send/cancel`,
                data
            });
        },


        terminate(data) {
            return http.json({
                url: `/order/add/send/terminate`,
                data
            });
        },


    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/orderAddSend.js